import { useEffect, useCallback } from 'react';
import { useRoutes } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@store';
import { setActivePermissions } from './store/dictionaries/slices';
import {
  useLazyGetAmlPermissionsQuery,
  useLazyGetAmlWhitelabelQuery,
} from './store/dictionaries/services';
import Blacklist from './routes/blacklist';
import Settings from './routes/risk-levels';
import TransactionMonitoringRules from './routes/transaction-monitoring-rules';
import GeogaphicalRoutes from './routes/geographical';
import TransactionsRiskRoutes from './routes/transactions-risk';
import IndividualClientsRiskRoutes from './routes/individual-clients-risk';
import CorporateClientsRiskRoutes from './routes/corporate-clients-risk';

export const routes = [
  Blacklist,
  Settings,
  TransactionMonitoringRules,
  GeogaphicalRoutes,
  TransactionsRiskRoutes,
  IndividualClientsRiskRoutes,
  CorporateClientsRiskRoutes,
];

const AmlKycRoutes = () => {
  const elements = useRoutes(routes);

  const dispatch = useAppDispatch();

  const { activePermissions, factors, whitelabel } = useAppSelector(
    (state) => state.amlDictionaries,
  );

  const [getAmlPermissions] = useLazyGetAmlPermissionsQuery();
  const [getAmlWhiteLabel] = useLazyGetAmlWhitelabelQuery();

  const getAmlPermissionsAction = useCallback(() => {
    getAmlPermissions();
  }, []);

  const permissions = JSON.parse(
    localStorage.getItem('activePermissions') as string,
  );

  useEffect(() => {
    const companyName = localStorage.getItem('companyName');

    if (!companyName) {
      getAmlWhiteLabel();
    }
  }, []);

  useEffect(() => {
    if (whitelabel) {
      localStorage.setItem('companyName', whitelabel?.data?.value?.companyName);
    }
  }, [whitelabel]);

  useEffect(() => {
    if (permissions && !activePermissions) {
      dispatch(setActivePermissions(permissions));
    } else if (!permissions && !activePermissions) {
      getAmlPermissionsAction();
    }
  }, [
    permissions,
    getAmlPermissionsAction,
    dispatch,
    activePermissions,
    factors,
  ]);

  return elements;
};

export default AmlKycRoutes;
